import { coerceFacet, emptyFacet, parseFacetMode, type FacetValue } from '@/lib/facet'

export type DeskFacets = {
  q: string
  status: FacetValue
  utm_source: FacetValue
  utm_medium: FacetValue
  utm_campaign: FacetValue
  kyc_tier: FacetValue
  risk_band: FacetValue
}

export function emptyDeskFacets(): DeskFacets {
  return {
    q: '',
    status: emptyFacet(),
    utm_source: emptyFacet(),
    utm_medium: emptyFacet(),
    utm_campaign: emptyFacet(),
    kyc_tier: emptyFacet(),
    risk_band: emptyFacet(),
  }
}

export function facetFromSearch(sp: URLSearchParams, name: string): FacetValue {
  const values = sp.getAll(name)
  if (!values.length) {
    const legacy = sp.get(`${name}_filter`)
    if (legacy) return { values: [legacy], mode: 'in' }
    return emptyFacet()
  }
  return { values, mode: parseFacetMode(sp.get(`${name}_mode`)) }
}

export function filtersFromSearch(sp: URLSearchParams): DeskFacets {
  return {
    q: sp.get('q') || '',
    status: facetFromSearch(sp, 'status'),
    utm_source: facetFromSearch(sp, 'utm_source'),
    utm_medium: facetFromSearch(sp, 'utm_medium'),
    utm_campaign: facetFromSearch(sp, 'utm_campaign'),
    kyc_tier: facetFromSearch(sp, 'kyc_tier'),
    risk_band: facetFromSearch(sp, 'risk_band'),
  }
}

export function writeFacet(cur: URLSearchParams, name: string, facet: FacetValue) {
  cur.delete(name)
  cur.delete(`${name}_mode`)
  for (const value of facet.values) cur.append(name, value)
  if (facet.mode === 'nin' && facet.values.length) cur.set(`${name}_mode`, 'nin')
}

export function labels(values: string[]): { value: string; label: string }[] {
  return values.map((value) => ({ value, label: value }))
}

export type { SortOrder, SortState } from '@/lib/sort-url'
export { cycleSort, sortFromSearch, writeSort } from '@/lib/sort-url'

export { coerceFacet }
